var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgZhCninline = function SvgZhCninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zh-cn_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDE02",
    d: "m9.59 4.18.634.307L10.73 4l-.096.697.62.333-.692.124-.124.692-.332-.62-.698.096.487-.507zm4.017 2.533-.306.633.487.508-.697-.096-.332.62-.124-.692-.693-.124.62-.333-.096-.696.508.487zm-.824 3.254.23.665.704.015-.56.424.204.675-.578-.402-.578.402.203-.675-.56-.424.703-.015zM9.59 12.793l.634.306.507-.487-.096.698.62.332-.692.124-.124.692-.332-.62-.698.096.487-.507zM6.028 5.88l.8 2.3 2.434.05-1.94 1.47.705 2.33-1.999-1.39-1.998 1.39.705-2.33-1.94-1.47 2.433-.05z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "zh-cn_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgZhCninline;